import { render, staticRenderFns } from "./KompetisiKlasemen.vue?vue&type=template&id=1ca24a87&scoped=true&"
import script from "./KompetisiKlasemen.vue?vue&type=script&lang=js&"
export * from "./KompetisiKlasemen.vue?vue&type=script&lang=js&"
import style0 from "./Overview.scss?vue&type=style&index=0&id=1ca24a87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca24a87",
  null
  
)

export default component.exports